import { render, staticRenderFns } from "./ResponsibilityPurposeTab.vue?vue&type=template&id=2a37c603&scoped=true"
import script from "./ResponsibilityPurposeTab.vue?vue&type=script&lang=js"
export * from "./ResponsibilityPurposeTab.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilityPurposeTab.vue?vue&type=style&index=0&id=2a37c603&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a37c603",
  null
  
)

export default component.exports